<h1 class="mf-popup-title">Zdravljenje</h1>
<div class="m-portlet mf-portlet-gray__gray-background mb-0">
    <div class="m-portlet__body">
        <div class="m-content">
            <div class="row">
                <div class="col-xl-9 col-lg-9 mf-content-portfolio-overflow">
                    <div *ngIf="resRequestData.isTreatmentCreated; else treatmentnotcreated">
                        <trt-wid-m-term-gen *ngIf="isGeneratorLoaded" (onCloseGenerator)="onCloseGenerator()"></trt-wid-m-term-gen>
                        <div *ngIf="isLoaded">
                            <div [formGroup]="itemForm" ngxsForm="treatmentstate.itemForm" ngxsFormDebounce="500">
                                <div *ngFor="let item of itemForm?.controls.items['controls']; let i = index">
                                    <ng-container formArrayName="items">
                                        <div [formGroupName]="i">
                                            <trt-wid-m-term-item
                                                *ngIf="item?.value?.itemType === 'TERM'"
                                                [termNumber]="i + 1"
                                                [termItemForm]="item"
                                                (onClosePopup)="onClosePopup()"
                                            ></trt-wid-m-term-item>

                                            <trt-wid-m-note-item *ngIf="item?.value?.itemType === 'NOTE'" [noteItemForm]="item"></trt-wid-m-note-item>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #treatmentnotcreated>
                        <h4 class="text-center">Zdravljenje ni ustvarjeno</h4>
                    </ng-template>
                </div>
                <div class="col-xl-3 col-lg-3">
                    <div class="m-portlet">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">Zdravljenje</h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body">
                            <trt-wid-m-details
                                [form]="treatmentDetailsForm"
                                [isSubmited]="isSubmited"
                                (onAddEvent)="addOneNewTerm()"
                                (onSelectFromCalendar)="addTermFromCalendar()"
                            ></trt-wid-m-details>
                        </div>
                    </div>
                    <portfolio-list
                        [type]="pfType.TERM"
                        [data]="portfolioPapers"
                        [isEditable]="false"
                        [customer]="resRequestData?.customer"
                    ></portfolio-list>
                    <div class="m-portlet">
                        <div class="m-portlet__body">
                            <button
                                *ngIf="!resRequestData?.isTreatmentCreated"
                                (click)="createTreatment()"
                                class="btn btn-outline-accent m-btn m-btn--icon m-btn--pill btn-block"
                            >
                                <span>Ustvari zdravjenje</span>
                            </button>
                            <ng-container *ngIf="resRequestData?.isTreatmentCreated">
                                <button (click)="addTermFromCalendar()" class="btn btn-outline-accent m-btn m-btn--pill m-btn--custom btn-block">
                                    <span>
                                        <span>Izberi termin iz koledarja</span>
                                    </span>
                                </button>
                                <button (click)="showTermGenerator()" class="btn btn-outline-accent m-btn m-btn--pill m-btn--custom btn-block">
                                    <span>
                                        <span>Generiraj termin</span>
                                    </span>
                                </button>
                                <button (click)="addTreatmentEvent()" class="btn btn-outline-accent m-btn m-btn--pill m-btn--custom btn-block">
                                    <span>
                                        <span>Dodaj dogodek</span>
                                    </span>
                                </button>
                                <button
                                    (click)="updateReservationsTreatment()"
                                    class="btn btn-outline-accent m-btn m-btn--icon m-btn--pill btn-block"
                                >
                                    <span>Shrani spremembe</span>
                                </button>
                            </ng-container>
                        </div>

                        <div class="m-portlet__foot">
                            <button (click)="onClosePopup()" class="btn btn-outline-warning m-btn m-btn--pill btn-block">
                                <span>
                                    <span>Zapri</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
